<template>
  <div id="">
    <v-row no-gutters>
      <v-col>
        <v-progress-linear
          :active="loadingData"
          color="accent"
          :indeterminate="true"
        />
      </v-col>
    </v-row>

    <v-card
      v-for="(dataItem, index) in dataTableArray"
      :key="index"
      class=" table-card"
      :class="{ 'ma-md-3': dataTableArray && dataTableArray.length > 1 }"
    >
      <v-card-title
        v-show="dataTableArray && dataTableArray.length > 1"
        primary-title
        class="pb-0 pl-2"
      >
        <div>
          <h3 class="title mb-0">
            {{ dataItem.title }}
          </h3>
        </div>
      </v-card-title>

      <ag-table
        v-show="dataItem.data && dataItem.data.length > 0"
        :is-full-height="dataTableArray && dataTableArray.length == 1"
        :data-table="dataItem.data"
        sidebar-clickeable
        :with-totals-footer="true"
        :totales="dataItem.totalHeader"
        :with-sidebar-extended="false"
        :config="tableConfig"
        @click-sidebar="showDialog"
      />
    </v-card>

    <v-alert
      v-if="
        dataTableArray &&
          dataTableArray.length == 1 &&
          dataTableArray[0].data &&
          dataTableArray[0].data.length == 0
      "
      v-show="!loadingDate"
      border="left"
      colored-border
      type="warning"
      icon="warning"
      elevation="2"
      class="ma-4"
    >
      Sin datos para mostrar
    </v-alert>

    <list-tarja-dialog
      v-model="showedDialog"
      :trabajador="dialogItem.trabajador"
      :centros-costo-dialog="dialogItem.centrosCostoIds"
      :labores-dialog="dialogItem.laboresIds"
      :sub-labores-dialog="dialogItem.subLaboresIds"
      :dates="datesDialog"
      :fullscreen="isMobile"
      @change="changeListTarjas()"
    />
  </div>
</template>
<script>
import agTable from "@/components/agTable";
//import remuneracionesModel from "@/models/remuneracionesModel";
//import trabajadorModel from "@/models/trabajadorModel";
//import axios from "axios";
import moment from "moment";
import listTarjaDialog from "@/components/listTarjaDialog";
//import asistencia from "@/views/asistencia"
import _ from "lodash";
import XLSX from "xlsx";

export default {
  name: "LibroRemuneraciones",
  components: {
    agTable,
    listTarjaDialog
    //asistencia
  },
  props: {
    trabajadores: { type: Array, default: () => [] },
    contratistas: { type: Array, default: () => [] },
    dataTable: { type: Object, default: () => {} },
    dates: { type: Object, default: null}
  },
  data: () => ({
    tableConfig: {
      header: [
        {
          label: "Jornadas Totales",
          print: false, //"Jornadas",
          mobile: "Jor",
          value: "jornadas",
          totalPrefix: "∑",
          round: 2,
          tooltip: ""
        },

        {
          label: "Jornadas / ha",
          print: false, //"Jornadas/ha",
          mobile: "Jo/ha",
          value: "jornadas_ha",
          round: 2,
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          average: true,
          tooltip: ""
        },

        {
          label: "Rendimiento / jor",
          print: false, //"Rend/jo",
          mobile: "Jo/ha",
          value: "rendimiento_jr",
          totalPrefix: "X̅",
          round: 2,
          tooltip: "",
          optional: true
        },

        {
          label: "Valor dia",
          print: "Valor Dia",
          mobile: "valor/dia",
          value: "dia_jr",
          round: 0,
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          tooltip: "",
          currency: true,
          average: true,
          optional: true,
          print_width: "lg"
        },

        {
          label: "Precio Trato",
          print: "Precio Trato",
          mobile: "valor/trato",
          value: "precio_trato",
          round: 0,
          prefix: "$",
          totalPrefix: "X̅",
          currency: true,
          tooltip: "",
          optional: true
        },

        {
          label: "Valor trato",
          print: "Valor trato",
          mobile: "Valor trato",
          value: "valor_trato",
          round: 0,
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          currency: true,
          average: true,
          tooltip: "",
          optional: true,
          print_width: "lg"
        },

        {
          label: "Bonos / Jornadas",
          print: "Bonos / Jor",
          mobile: "Bonos Jor",
          value: "bono_jr",
          round: 0,
          prefix: "$",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          currency: true,
          average: true,
          tooltip: "",
          print_width: "lg"
        },

        {
          label: "Total Horas extras",
          print: "Total Horas extras",
          mobile: "Total Hrs ext.",
          value: "horas_extras",
          totalPrefix: "∑",
          round: 1,
          tooltip: ""
        },

        {
          label: "Valor Horas extras",
          print: "Valor Horas extras",
          mobile: "$ Hrs ext.",
          value: "valor_horas_extras",
          totalPrefix: "X̅",
          round: 0,
          prefix: "$",
          currency: true,
          tooltip: "",
          print_width: "lg"
        },

        {
          label: "Sem Corrida",
          print: "Sem Corrida",
          mobile: "sem corr",
          value: "semana_corrida",
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          round: 0,
          currency: true,
          tooltip: ""
        },

        {
          label: "Liquido jr",
          print: false, //"Liquido jr",
          mobile: "Liquido jr",
          value: "liquido_jr",
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          round: 0,
          currency: true,
          average: true,
          tooltip: ""
        },

        {
          label: "Liquido",
          print: "Liquido",
          mobile: "Liquido",
          value: "liquido",
          totalPrefix: "∑",
          currency: true,
          prefix: "$",
          round: 0,
          tooltip: "",
          print_width: "lg" // lg, xl, xxl
        }
      ],
      sidebar: {
        title: "Items",
        label: "nombre"
      }
    },

    dateSelected: moment().format("YYYY-MM-DD"),

    dateMenuMonth: false,
    //dateMenuInicio      : false,
    //dateMenuFin         : false,

    datesDialog: {
      // para dialogo de tarjas de trabajador
      dateInicio: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      dateFin: moment()
        .endOf("month")
        .format("YYYY-MM-DD")
      //dateMonth   : moment().startOf('month').format("YY-MM"),
    },
    /*
    dates: {
      dateInicio  : moment().startOf('month'),
      dateFin     : moment().endOf('month'),
      dateMonth   : moment().startOf('month').format("YY-MM"),
    },
    */
    //dataTable    : [],
    //trabajadores : [],
    dataTableArray: [],
    data: [],
    loadingData: false,
    loadingDate: false,
    showedDialog: false,
    dialogItem: null,

    dialogItemEmpty: {
      trabajador: [],
      centrosCostoIds: [],
      laboresIds: [],
      subLaboresIds: []
    }
  }),
  computed: {
    empresaSelected() {
      return this.$store.getters.empresaSelected;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    }
  },
  watch: {
    empresaSelected() {
      //this.getData();
    },
    dates: {
      deep: true,
      handler() {
        console.log("change dates");
        this.changeDates();
      }
    },
    group() {
      console.log("group changed");
      //this.prepareData();
    },
    dataTable() {
      this.dataTableArray = this.parseDataTable(this.dataTable);
    }
  },
  created() {
    this.dataTableArray = this.parseDataTable(this.dataTable);
    this.dialogItem = _.clone(this.dialogItemEmpty);
    this.changeDates();
    //this.getData();
  },
  methods: {
    changeDates() {
      this.datesDialog = {
        dateInicio: this.dates.dateInicio.format("YYYY-MM-DD"),
        dateFin: this.dates.dateFin.format("YYYY-MM-DD")
        //dateMonth  : dates.dateInicio.format("YY-MM")
      };
      this.dateSelected = this.dates.dateInicio.format("YYYY-MM-DD");
      //this.getData();
    },

    changeListTarjas(tarjas) {
      this.$emit("change", tarjas);
    },

    parseDataTable(dataTable) {
      var self = this;
      if (dataTable.totales) {
        dataTable.totalHeader = _.reduce(
          this.tableConfig.header,
          (collector, hi) => {
            var prefix = hi.prefix || "";
            var suffix = hi.suffix || "";
            var value = dataTable.totales[hi.value];
            var label = "-";

            if (_.isNumber(value)) {
              label =
                prefix +
                (hi.currency
                  ? self.formatPrice(_.round(value, 0))
                  : _.round(value, 2)) +
                suffix;
            }

            collector[hi.value] = {
              label,
              value,
              prefix,
              suffix,
              headerItem: hi, // item del header que corresponde a la columna
              isCurrency: hi.currency
            };
            return collector;
          },
          {}
        );
      }

      //aunque se devuelve el array, solo se usa un item, no se elimina
      //la logica de array de datatable, porque se puede necesitar en un futuro
      //para mostrar varias tablas
      return [dataTable];
    },

    formatPrice(value) {
      let val = (value / 1).toString().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    showDialog(params) {
      this.dialogItem = _.clone(this.dialogItemEmpty);
      var ci = params.item.clickItem;

      this.dialogItem.laboresIds = ci.labor ? [ci.labor] : [];
      this.dialogItem.subLaboresIds = ci.sub_labor ? [ci.sub_labor] : [];
      this.dialogItem.centrosCostoIds = ci.centros_costo
        ? [ci.centros_costo]
        : [];
      this.dialogItem.trabajador = ci.trabajador
        ? _.find(this.trabajadores, { id: ci.trabajador })
        : null;

      if (this.dialogItem.subLaboresIds.length > 0) {
        this.dialogItem.laboresIds = [];
      }

      this.hideDialog();
      this.showedDialog = true;
    },
    hideDialog() {
      this.showedDialog = false;
    },

    //funcion recursiva
    parseDataAoA(headerVars, data, vars, parentData = {}, indice = 0) {
      return _.reduce(
        data,
        (accumulator, d) => {
          let actualParentData = {};
          actualParentData[vars[indice] + "_label"] = d.nombre;
          parentData = { ...parentData, ...actualParentData };

          if (d[vars[indice + 1]]) {
            accumulator = accumulator.concat(
              this.parseDataAoA(
                headerVars,
                d[vars[indice + 1]],
                vars,
                parentData,
                indice + 1
              )
            );
          } else {
            let rowData = { ...d, ...parentData };
            var parsed = _.map(headerVars, h => {
              return rowData[h.value] ? rowData[h.value] : null;
            });
            accumulator.push(parsed);
          }

          return accumulator;
        },
        []
      );
    },

    downloadXls(name) {
      const fileName = name || "archivo";
      const workbook = XLSX.utils.book_new();
      //dataTable
      _.forEach(this.dataTableArray, dta => {
        let versionSheetName = 1;
        let xlsDefault = { wpx: 100 };
        let headerVars = _.clone(this.tableConfig.header);

        this.dataTable.vars
          .slice()
          .reverse()
          .forEach(v => {
            if (v) {
              headerVars.unshift({
                label: v,
                value: v + "_label",
                xls: { wpx: 150 }
              });
            }
          });

        let header = _.map(headerVars, h => h.label);

        let dataAoA = this.parseDataAoA(
          headerVars,
          dta.data,
          this.dataTable.vars
        );

        dataAoA.unshift(header);

        let sheet = XLSX.utils.aoa_to_sheet(dataAoA);

        let sheetName =
          dta.title.length > 30 ? dta.title.substr(0, 29) : dta.title;

        //agrega numeros al final del nombre en el caso de existir nombres repetidos
        while (_.indexOf(workbook.SheetNames, sheetName) > -1) {
          versionSheetName++;
          sheetName = sheetName.substr(0, 26) + "_" + versionSheetName;
        }

        sheet["!cols"] = _.map(headerVars, h => h.xls || xlsDefault);
        XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
      });
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }
  }
};
</script>
<style lang="scss">
@media print {
  .table-card {
    box-shadow: none !important;
  }
}
.table-card {
  .ag-table.full-height {
    height: calc(100vh - 160px) !important;
  }
}
</style>
